import moment from "moment";
import cookie from "js-cookie";

const expiresIn = 0.5; // days

export default cookieName => ({
  get: () => {
    return cookie.get(cookieName);
  },
  set: () => {
    const expires = moment()
      .add(expiresIn * 24, "hours")
      .format("YYYYMMDD-HHMM");

    cookie.set(cookieName, expires, { expires: expiresIn });
  },
  remove: () => {
    cookie.set(cookieName, 0, { expires: 0 });
  }
});
